import {lazy, Suspense, useRef} from 'react'

import {twMerge} from '@sdox/utils'
import {Loading} from '@sdox/ui'

import {useDesignDebugger} from '../Debugger'
import {useIsEditable} from '../DragAndDrop'

import type {ReactNode} from 'react'
import type {ClassNameValue} from 'tailwind-merge'

export interface PageItemProps {
  children?: ReactNode
  className?: ClassNameValue
}

const DroppablePanel = lazy(() => import('../DragAndDrop/DroppablePanel'))

export const PageItem = (props: PageItemProps) => {
  const isEditable: boolean = useIsEditable()
  if (isEditable) {
    return (
      <Suspense fallback={<Loading />}>
        <DroppablePanel>
          <PageItemContent {...props} />
        </DroppablePanel>
      </Suspense>
    )
  }

  return (
    <PageItemContent {...props} />
  )
}

const PageItemContent = (props: PageItemProps) => {
  const {children, className} = props
  const ref = useRef<HTMLDivElement>(null!)
  useDesignDebugger(ref, 'PageItem')

  return (
    <div
      ref={ref}
      className={twMerge(
        'px-spacing-20 py-spacing-56 @medium/page:p-container-large',
        'rounded-radius-page',
        'grid bg-surface-primary',
        className,
      )}
    >
      <div className={'@container'}>
        {children}
      </div>
    </div>
  )
}
